import React from 'react'
import { cn } from '../../utils/utils';
import { SpaceIcon } from 'lucide-react';
import Winner from '../../assets/icons/winner.svg'

type Props = {
    data:any
    isGuest:boolean
    type:'Semi'| 'Quarter' | "Round16" | "Round32"
}
function ChartTeamBox({data, type,isGuest }: Props) {
    console.log(data);
  
    return (
      <div className='team--box--shadow flex-1 border-2 bg-[#FFF] rounded-[12px] border-primary h-full flex justify-center items-center relative flex-col gap-1 w-full min-h-[40px] '>
       
        <div className={cn("team_banner text-white  rounded-t-lg rounded-b-none absolute grid place-content-center w-[calc(100%+20px)] -left-[10px] h-[5vh] min-h-[15px] bg-primary top-[50%] -translate-y-1/2 text-sm  ",type === 'Semi' && 'before:border-[5px] before:w-[10px] before:h-[10px] after: after:border-[5px] after:w-[10px] after:h-[10px] text-base', type === 'Quarter' && 'before:border-[5px] before:w-[10px] before:h-[10px] after: after:border-[5px] after:w-[10px] after:h-[10px]')}>
          {data?.team_line_ids[isGuest?1:0]?.team_id?.name || data?.match_code}
        </div>
       
        </div>
    )
  }

export default ChartTeamBox